import {
    GET_CUSTOMER_ERROR,
    GET_CUSTOMER_START,
    GET_CUSTOMER_SUCCESS,
} from './types';

const initialState = {
    customers: [],
    isLoading: false,
    total: 0,
    page: 1,
    limit: 10,
};

const customerReducers = (state = initialState, action) => {
    const { type, payload, err } = action;
    switch (type) {
        case GET_CUSTOMER_START:
            return {
                ...state,
                isLoading: true,
                customers: [],
            };
        case GET_CUSTOMER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                customers: payload.customers,
                total: payload.total,
                page: payload.page,
                limit: payload.limit,
            };
        case GET_CUSTOMER_ERROR:
            return {
                ...state,
                isLoading: false,
                customers: [],
            };

        default:
            return state;
    }
};

export default customerReducers;
